import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import OnboardingBanner from './components/OnboardingBanner';
import DancingPepino from './components/DancingPepino';
import './AppLayout.css';

const AppLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem('sidebar-collapsed') === 'true';
  });

  // Listen for localStorage changes (from Sidebar)
  useEffect(() => {
    const handleStorageChange = () => {
      setIsCollapsed(localStorage.getItem('sidebar-collapsed') === 'true');
    };

    // Custom event for same-tab updates
    window.addEventListener('sidebar-toggle', handleStorageChange);
    // Storage event for cross-tab updates
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('sidebar-toggle', handleStorageChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div className="video-layout">
      <Sidebar />
      <main className={`video-main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
        <OnboardingBanner />
        {children}
      </main>
      <DancingPepino />
    </div>
  );
};

export default AppLayout;